import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import ProduttivoMuiTheme from '@/javascript/presentation/theme/produttivo-mui-theme'
import { makeRemoteLoadResourcePlaceList, makeRemoteLoadResourcePlaceListByIds } from '@/javascript/main/factories/usecases'
import { AccountMemberList } from '@/javascript/presentation/pages/account-members'

const rootEl = document.getElementById('account-member-list-filters-root')

export const makeAccountMemberFilters = () => {
  const hasAddMemberPermission = rootEl.getAttribute('data-add-member') === 'true'

  return(
  <ThemeProvider theme={ProduttivoMuiTheme}>
    <AccountMemberList
      hasAddMemberPermission={hasAddMemberPermission}
      fetchResourcePlaces={makeRemoteLoadResourcePlaceList()}
      fetchResourcePlaceByIds={makeRemoteLoadResourcePlaceListByIds()}
    />
  </ThemeProvider>
  )
}

if (rootEl !== null) {
  const root = createRoot(rootEl)
  root.render(makeAccountMemberFilters())
}
